import { AlphaGCircleOutlineIcon } from './AlphaGCircleOutlineIcon';

/**
 * author: Contributors
 * id 780BAB12-D647-4E55-BD56-487367D70FD0
 * name alpha-g-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-g-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetGCircleOutlineIcon = AlphaGCircleOutlineIcon;
export default AlphabetGCircleOutlineIcon